export default __webpack_public_path__ + "static/media/portfolio-wilo-4.2a0993a5.jpg";